module.exports = __webpack_public_path__ + "static/media/claudia.a3f8c6d6.png";